import axios from "axios";

export const updateUserTask = async (action, userId, taskId) => {
    await axios.post(`${process.env.REACT_APP_BASE_URL}/api/assign_user_task`, {
        user_id:userId,
        project_task_id:taskId,
        action
    });
};